import React, { useState } from 'react';
import { detailToString } from '../utils/apiError';

export default function LoginPage({ onLogin, apiBaseUrl }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch(`${apiBaseUrl}/auth/site-login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      if (res.status === 429) {
        const data = await res.json();
        setError(detailToString(data.detail) || 'Too many attempts. Please wait.');
      } else if (!res.ok) {
        setError('Invalid credentials.');
      } else {
        const data = await res.json();
        onLogin(data.token);
      }
    } catch {
      setError('Unable to connect. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <div style={styles.header}>
          <h2 style={styles.title}>JobQ</h2>
          <p style={styles.subtitle}>Sign in to continue</p>
        </div>
        <form onSubmit={handleSubmit} style={styles.form}>
          <div className="mb-3">
            <label htmlFor="site-username" className="form-label">Username</label>
            <input
              id="site-username"
              name="username"
              type="text"
              autoComplete="username"
              className="form-control form-control-lg"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoFocus
            />
          </div>
          <div className="mb-3">
            <label htmlFor="site-password" className="form-label">Password</label>
            <input
              id="site-password"
              name="password"
              type="password"
              autoComplete="current-password"
              className="form-control form-control-lg"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && (
            <div className="alert alert-danger py-2" role="alert">
              {error}
            </div>
          )}
          <button
            type="submit"
            className="btn btn-primary btn-lg w-100"
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    background: 'linear-gradient(135deg, rgba(0,123,255,1) 0%, rgba(32,201,151,1) 100%)',
  },
  card: {
    width: '100%',
    maxWidth: 400,
    margin: '1rem',
    padding: '2rem',
    borderRadius: 12,
    backgroundColor: '#fff',
    boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
  },
  header: {
    textAlign: 'center',
    marginBottom: '1.5rem',
  },
  title: {
    fontSize: '2rem',
    fontWeight: 700,
    color: '#007bff',
    margin: 0,
  },
  subtitle: {
    color: '#6c757d',
    margin: '0.25rem 0 0',
  },
  form: {},
};
